import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/services/api";
import { useAuth } from "@/contexts/AuthContext";

interface UnreadCountResponse {
  count: number;
}

export function useNotificationCount() {
  const { isAuthenticated } = useAuth();

  const query = useQuery<UnreadCountResponse>({
    queryKey: ["notifications", "unread-count"],
    queryFn: () => apiFetch<UnreadCountResponse>("/notifications/unread-count"),
    enabled: isAuthenticated,
    refetchInterval: 60000,
    staleTime: 30000,
  });

  return {
    count: query.data?.count ?? 0,
    isLoading: query.isLoading,
  };
}
